import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import Footer from "@/components/Footer";

// Minimal privacy policy — applies site-wide, linked from the ORYVEN consent checkbox.
export default function Privacy() {
  return (
    <div className="flex min-h-screen flex-col bg-sa-bg" data-testid="privacy-page">
      <header className="mx-auto flex w-full max-w-6xl items-center justify-between px-6 py-5">
        <Link to="/" data-testid="privacy-logo">
          <Logo iconClass="h-9 w-9" textClass="text-xl" />
        </Link>
        <Link to="/" data-testid="privacy-back" className="text-sm font-medium text-sa-muted transition-colors hover:text-sa-forest">
          Back to home
        </Link>
      </header>
      <main className="mx-auto w-full max-w-3xl flex-1 px-6 py-10">
        <h1 className="font-display text-4xl font-medium tracking-tight text-sa-forest">Privacy Policy</h1>
        <p className="mt-2 text-sm text-sa-muted">SuperAge Health™ · Last updated October 2026</p>
        <div className="mt-8 space-y-6 text-[15px] leading-relaxed text-sa-muted">
          <p>
            <strong className="text-sa-forest">What we collect.</strong> When you use our website you may share
            your name, email address, mobile number, and health-related answers you choose to provide in the
            liver health assessment. When you register interest in ORYVEN, we store only your name, email,
            and optionally your mobile number and interest category.
          </p>
          <p>
            <strong className="text-sa-forest">How we use it.</strong> Your information is used to deliver the
            services you request — assessment results, appointment booking, consultations, and product launch
            updates you have consented to receive. We do not sell or share your personal information with
            third parties for their marketing.
          </p>
          <p>
            <strong className="text-sa-forest">Storage & access.</strong> Data is stored securely and access is
            restricted to authorized SuperAge Health administrators. Payment transactions are processed by
            Razorpay; we never store your card details.
          </p>
          <p>
            <strong className="text-sa-forest">Your choices.</strong> You may request access, correction, or
            deletion of your personal data at any time by writing to us.
          </p>
          <p>
            <strong className="text-sa-forest">Contact.</strong> For any privacy questions, email{" "}
            <a href="mailto:contact@superagehealth.com" className="text-sa-copper underline underline-offset-2">
              contact@superagehealth.com
            </a>{" "}
            or call +91 78619 17281.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
